export function Closed() {
  return <span className="text-red-800">X</span>
}
